import intl from "react-intl-universal";
import {IDataClientService} from "../../platform/services/data/DataClientService";
import {IAuthService} from "../../platform/services/auth/AuthService";
import {IssueGqlProvider} from "../../stores/reliability/IssueGqlProvider";
import {snackBarRef} from "../../stores/snackbarRef";

export const deleteIssue = async (
    dataClientService: IDataClientService,
    authService: IAuthService,
    wsId: string,
    id: string,
): Promise<void> => {
    await new IssueGqlProvider({dataClientService, authService}, wsId).delete(id);
    snackBarRef.current?.enqueueSnackbar({
        message: intl.get('issues.delete.success').d('Issue deleted'),
    });
};
